import axios, { AxiosInstance } from 'axios';

const LOYALTY_API_ENDPOINT = process.env.LOYALTY_API_ENDPOINT;

/**
 * Запрос в loyalty-api https://master.api-loyalty.services.t2.ertelecom.ru/docs
 */

export default function createLoyaltyApiRequest(domain: string, accessToken: string): AxiosInstance {
    const headers = {
        'Domain': domain,
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
    };

    return axios.create({
        baseURL: LOYALTY_API_ENDPOINT,
        headers: headers
    });
}
